export default {"src":"/_next/static/media/consentToCheckEligibility.a210a448.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};